import React, { useContext, useEffect, useState } from 'react';
import getLicense from './functions/getLicense';
import checkLicense from './functions/checkLicense';
import startTrial from './functions/startTrial.js';
import Loader from '../Loader.jsx';
import Config from '../../Config.js';
import { AppContext } from '../../AppContext.js';
import ButtonPrimary from '../buttons/ButtonPrimary.jsx';
import { ADOxxLogout } from '../oauth/OAuth.js';

const LicenseProvider = ({ children }) =>
{
    const { setLicense } = useContext(AppContext);
    const [loading, setLoading] = useState(false)
    const [userLicenseStatus, setUserLicenseStatus] = useState(null);
    const [error, setError] = useState({
        isError: false,
        message: ""
    })

    function removeProtocol(url)
    {
        return url.replace(/\//g, '_');
    }

    const environmentID = removeProtocol(localStorage.getItem('baseURL'));

    const fetchData = async () =>
    {
        if (!environmentID || environmentID.length === 0)
        {
            console.error('Missing environment ID.');
            return;
        }

        const aLicenseData = await getLicense(environmentID);
        if (!aLicenseData.isOk)
        {
            setError({
                isError: true,
                message: aLicenseData.message
            })
        }
        const sCheckLicense = await checkLicense(aLicenseData, setLicense);

        setError({
            isError: false,
            message: ""
        })

        if (sCheckLicense === 1)
        {
            setLicense(prev => ({
                ...prev,
                type: 'Trial'
            }));
        }

        setUserLicenseStatus(sCheckLicense);
    };

    useEffect(() =>
    {
        fetchData();
    }, []);


    const handleStartTrial = async () =>
    {
        try
        {
            setLoading(prevState => ({
                ...prevState,
                startTrial: true
            }));
            await startTrial(environmentID);
            await fetchData(); // Refresh license status after starting trial
        } catch (error)
        {
            console.error('Error starting trial:', error);
        } finally
        {
            setLoading(prevState => ({
                ...prevState,
                startTrial: false
            }));
        }
    };

    const handleCancelTrial = async () =>
    {
        try
        {
            setLoading(prevState => ({
                ...prevState,
                cancelTrial: true
            }));
            ADOxxLogout();

        } catch (error)
        {
            console.error('Error starting trial:', error);
        }
    };

    return (
        <div>
            {error.isError &&
                <div className="container">
                    <p className='pl-4 pr-4 p-2 alert-danger'>{error.message}</p>
                </div>
            }
            {userLicenseStatus === null && error.isError === false && <Loader label={Config.strings.dropdowns.loadingSelection} labelDirection={"bottom"} />}

            {userLicenseStatus === 0 && <>
                <div className="container">
                    <p className='pl-4 pr-4 pb-2'>{Config.strings.license.noActive}</p>
                    <p className='pl-4 pr-4 pb-4'>{Config.strings.license.startTrial}</p>
                    <ButtonPrimary onClick={handleStartTrial} label={Config.strings.license.buttons.startTrial} loadingOnAction={loading.startTrial} />
                    <ButtonPrimary onClick={handleCancelTrial} label={Config.strings.license.buttons.cancel} loadingOnAction={loading.cancelTrial} />
                    <p className='pl-4 pr-4 pt-4'><a href={Config.rcwAppDocumentation} className='wrcLink'>{Config.strings.license.RCWdocumentation}</a></p>
                </div>
            </>}

            {userLicenseStatus === 1 && <>
                {children}
            </>}

            {userLicenseStatus === 2 && <>
                <div className="container">
                    <p className='pl-4 pr-4 pb-2'>{Config.strings.license.trialExpired}</p>
                    <p className='pl-4 pr-4'><a href={Config.rcwAppDocumentation} className='wrcLink'>{Config.strings.license.RCWdocumentation}</a></p>
                </div>
            </>}

            {userLicenseStatus === 3 && <>
                {children}
            </>}
            {userLicenseStatus === 4 && <>
                <div className="container">
                    <p className='pl-4 pr-4 pb-2'>{Config.strings.license.licenseExpired}</p>
                    <p className='pl-4 pr-4'><a href={Config.rcwAppDocumentation} className='wrcLink'>{Config.strings.license.RCWdocumentation}</a></p>
                </div>
            </>}
        </div>
    );
};

export default LicenseProvider;
